import { ChangeDetectorRef, Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'gestor';

  constructor(
    private cdr: ChangeDetectorRef
    ){}

  ngOnInit() {
    this.cdr.detectChanges();
  }
}
